import type {
  AddressBookCreateInput,
  AddressBookEntryDto,
  AddressBookPatchInput,
  CargoTemplateCreateInput,
  CargoTemplateDto,
  CargoTemplatePatchInput,
  CounterpartyCreateInput,
  CounterpartyDto,
  CounterpartyPatchInput,
} from '@expeditor/shared';
import { apiClient } from './client';

/**
 * Фабрика тонкой CRUD-обёртки для трёх личных справочников.
 *
 * Все три ресурса имеют одинаковый shape API — разница только в DTO-типах
 * и URL. Один фабричный generic сжимает три почти идентичных модуля в один.
 */
function makeBookApi<Item, Create, Patch>(base: string) {
  return {
    list(includeArchived = false): Promise<Item[]> {
      return apiClient
        .get<Item[]>(`${base}${includeArchived ? '?includeArchived=true' : ''}`)
        .then((r) => r.data);
    },
    create(dto: Create): Promise<Item> {
      return apiClient.post<Item>(base, dto).then((r) => r.data);
    },
    update(id: string, patch: Patch): Promise<Item> {
      return apiClient.patch<Item>(`${base}/${id}`, patch).then((r) => r.data);
    },
    archive(id: string): Promise<Item> {
      return apiClient.delete<Item>(`${base}/${id}`).then((r) => r.data);
    },
    restore(id: string): Promise<Item> {
      return apiClient.post<Item>(`${base}/${id}/restore`).then((r) => r.data);
    },
  };
}

export const addressBookApi = makeBookApi<
  AddressBookEntryDto,
  AddressBookCreateInput,
  AddressBookPatchInput
>('/address-book');

export const cargoTemplatesApi = makeBookApi<
  CargoTemplateDto,
  CargoTemplateCreateInput,
  CargoTemplatePatchInput
>('/cargo-templates');

export const counterpartiesApi = makeBookApi<
  CounterpartyDto,
  CounterpartyCreateInput,
  CounterpartyPatchInput
>('/counterparties');
